<div class="py-px-16 px-px-32">
    <div class="d-flex justify-content-between">
      <div class="fs-20 fw-7">{{ data ? 'Modifier une agence' : 'Ajouter une agence' }}</div>
      <div>
        <svg-icon src="assets/icons/close.svg" class="cursor-pointer" (click)="dialogRef.close()"></svg-icon>
      </div>
    </div>
    <div  [formGroup]="form">
      <app-custom-input
        [parentForm]="form" controlName="email"
        [errorMessage]="(this.form.get('mail')?.errors?.['email']) ? 'Veuillez entrer un email valide.' : ''"
        label="Email" [required]="true" innerClass="mt-px-16"></app-custom-input>
  
  
      <div class="row mt-px-16">
        <div class="col-6">
          <app-custom-input label="Nom d'agence" [parentForm]="form" controlName="name"
                            [required]="true"></app-custom-input>
        </div>
        <div class="col-6 ">
          <app-custom-input label="Siret" [parentForm]="form" controlName="siret" 
          [max]=14
          [errorMessage]="
      isFieldInvalid('siret', 'required')
        ? 'Le champ Siret est requis.'
        : isFieldInvalid('siret', 'maxlength')
        ? 'Le Siret ne peut pas dépasser 14 chiffres.'
        : isFieldInvalid('siret', 'pattern')
        ? 'Veuillez entrer un Siret valide (uniquement des chiffres).'
        : ''
    "
                            [required]="true"></app-custom-input>    
        </div>
      </div>
  
      <div class="row mt-px-16">
        <div class="col-6">
          <app-custom-input label="Adresse" [parentForm]="form" controlName="address"
                            [required]="true"></app-custom-input>
        </div>
        <div class="col-6">
          <label for="agencyResponsable">Responsable de l'agence</label>
          <select
            id="agencyResponsable"
            class="form-control"
            formControlName="agencyResponsable"
            [ngClass]="{ 'is-invalid': isFieldInvalid('agencyResponsable', 'required') }"
            style="padding: 12px 16px 12px 16px;"
          >
            <option value="" disabled selected>Choisir un responsable</option>
            <option *ngFor="let user of users" [value]="user.id">{{ user.firstName }}</option>
          </select>
          <div *ngIf="isFieldInvalid('agencyResponsable', 'required')" class="invalid-feedback">
            Le champ Responsable de l'agence est requis.
          </div>
        </div>
      </div>

    </div>
    <mat-dialog-actions align="end" class="mt-px-24">
      <app-button (handleClick)="dialogRef.close()" [stroked]="true" text="Annuler"></app-button>
      <app-button (handleClick)="addContact()"
                  [loading]="loading"
                  [disabled]="form.invalid || loading"
                  innerClass="ml-px-8"
                  [text]=" data ? 'Confirmer les changements': 'Ajouter agence'"></app-button>
    </mat-dialog-actions>
  </div>
